<template>
  <div class="ec-week-dates">
    <div style="width: 45px"></div>
    <div
      v-for="(date, index) in _currentRange"
      :key="index"
      class="ec-date-show"
    >
      <DateBox :date="date" />
    </div>
  </div>
  <div id="calendar-box">
    <div id="time-sheet">
      <div v-for="(time, index) in timeslots" :key="index" class="ec-time">
        {{ time }}
      </div>
    </div>
    <div class="ec-days">
      <div id="time-row-buffer" class="ec-lines">
        <div v-for="(line, index) in lines" :key="index" class="ec-line"></div>
      </div>
      <WeekDayComponent
        v-for="(day, index) in _currentRange"
        :key="index"
      ></WeekDayComponent>
    </div>
  </div>
</template>

<script setup>
import { times } from "./../../libs/util";
import WeekDayComponent from "./WeekDayComponent.vue";
import DateBox from "./calendar/date-box.vue";
import { useAppointmentStore } from "../../stores/appointmentsStore";
import { getDates } from "./../../libs/date";
import { computed } from "vue";
const appointmentStore = useAppointmentStore();

// Make _currentRange reactive to currentRange changes
const _currentRange = computed(() => {
  return getDates(
    appointmentStore.currentRange.start,
    appointmentStore.currentRange.end
  );
});

let slotMinTime = "08:00:00";
let slotMaxTime = "21:00:00";
let slotDuration = "00:60:00";
const timeslots = times(slotMinTime, slotMaxTime, slotDuration);
const lines = [];
lines.length = timeslots.length;
</script>

<style>
.ec-week-dates {
  display: flex;
}
.ec-date-show {
  flex: 1 1 0px;
  align-items: center;
  justify-content: center;
  display: flex;
}
</style>
